import React, { Component } from 'react';
import { connect } from 'react-redux';

import axios from 'axios';
import StripeCheckout from 'react-stripe-checkout';
import {addStripePopup} from '../../../redux/actions/AppAction'

import {
    Button,
    Grid,
} from 'semantic-ui-react';

import { translate } from "react-translate";

import API from '../../../services/api';

const STRIPE_PUBLISHABLE = "pk_live_aE6di6E1QkaShWPYXXiVaOIo";

const mapStateToProps = state => ({
    app: state.app
})


const mapActionToProps = ({
    addStripePopup: addStripePopup
})

class ConnectedCheckout extends Component {
    constructor(props) {
        super(props);

        this.state = {
            response: null,
            hasPaid: false,
        }

        this.closeModal = this.closeModal.bind(this)
    }

    handleSubmitPay(token) {
        var self = this;
        var form = new FormData();
        form.append("fkuidsub", this.props.app.pkuidsub);
        form.append("fkuiduser", this.props.app.id);
        form.append("stripe_token", token.id);
        API.createSub(this.props.app.token, form).then((res) => {
            self.closeModal(false);
        });
    }


    setStripeToken(stripe_token) {
        this.props.addStripeToken(stripe_token);
    }

    successPayment = data => {
        alert('Payment Successful');
        this.setStripeToken();
    };

    errorPayment = data => {
        alert('Payment Error');
    };

    onToken = (token) => {
        this.handleSubmitPay(token);
    }

    closeModal(value){
        this.props.addStripePopup(value)
    }


    render() {
        const {t} = this.props
        return (
            <Grid>
                <Grid.Column width={4}></Grid.Column>
                <Grid.Column textAlign='center' width={8}>
                    <StripeCheckout
                        name={t('pay')}
                        token={this.onToken}
                        stripeKey={STRIPE_PUBLISHABLE}>
                        <Button size='massive'
                        id="validBtn"
                        fluid>{t('pay')}
                        </Button>
                    </StripeCheckout>
                </Grid.Column>
                <Grid.Column width={4}></Grid.Column>
            </Grid>
        )
    }
}

const Checkout = connect(mapStateToProps, mapActionToProps)(ConnectedCheckout);
export default translate("Checkout")(Checkout);



// WEBPACK FOOTER //
// ./src/components/Protected/Extension/Checkout.js